import { render, staticRenderFns } from "./detailv2.vue?vue&type=template&id=7252b37e&scoped=true"
import script from "./detailv2.vue?vue&type=script&lang=js"
export * from "./detailv2.vue?vue&type=script&lang=js"
import style0 from "./detailv2.vue?vue&type=style&index=0&id=7252b37e&prod&lang=css"
import style1 from "./detailv2.vue?vue&type=style&index=1&id=7252b37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252b37e",
  null
  
)

export default component.exports